import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
interface DeckNavigationProps {
  currentSlide: number;
  totalSlides: number;
  goToNextSlide: () => void;
  goToPrevSlide: () => void;
}
const DeckNavigation: React.FC<DeckNavigationProps> = ({
  currentSlide,
  totalSlides,
  goToNextSlide,
  goToPrevSlide
}) => {
  return <div className="flex justify-between items-center mt-8 px-4" data-id="element-2423">
      <button onClick={goToPrevSlide} disabled={currentSlide === 0} className="flex items-center justify-center w-12 h-12 rounded-full bg-white border border-gray-200 hover:bg-gray-50 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2424">
        <ArrowLeftIcon className="h-6 w-6 text-indigo-600" data-id="element-2425" />
      </button>
      <div className="text-sm font-medium text-gray-600" data-id="element-2426">
        Slide {currentSlide + 1} of {totalSlides}
      </div>
      <button onClick={goToNextSlide} disabled={currentSlide === totalSlides - 1} className="flex items-center justify-center w-12 h-12 rounded-full bg-white border border-gray-200 hover:bg-gray-50 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2427">
        <ArrowRightIcon className="h-6 w-6 text-indigo-600" data-id="element-2428" />
      </button>
    </div>;
};
export default DeckNavigation;